// core version + navigation, pagination modules:
import WebXSwiper from "swiper";
import { Autoplay, Navigation } from "swiper/modules";
// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

document.addEventListener("DOMContentLoaded", function () {
    const sliders = document.querySelectorAll(".webx-swiper");
    const buttons = document.querySelectorAll(".swiper_button");
    sliders.forEach((slider) => {
        //get all elements withtin class="slider-content" and get the title attribute, then replace button contents for each button
        const titles = slider.querySelectorAll(".slider-content");
        titles.forEach((title, index) => {
            const titleText = title.getAttribute("title");
            if (titleText && buttons[index]) {
                buttons[index].innerHTML = titleText;
            }
        });

        const id = slider.id;
        const swiper = new WebXSwiper(slider, {
            modules: [Navigation, Autoplay],
            autoplay: slider.dataset.autoplay
                ? {
                      delay: slider.dataset.slidespeed ?? 5000,
                  }
                : false,
            speed: 1000,
            navigation: {
                nextEl: ".swiper-button-next-" + id,
                prevEl: ".swiper-button-prev-" + id,
            },
        });
        //find all swiper_button elements and add click event listener to them to change the slide to data-slide attribute
        swiper.on("slideChange", function () {
            buttons.forEach((button) => {
                button.classList.remove("active");
            });
            buttons[swiper.activeIndex].classList.add("active");
        });
        buttons.forEach((button) => {
            button.addEventListener("click", function () {
                swiper.slideTo(button.dataset.slide);
                button.classList.add("active");
            });
        });
    });
});
